import Assets from 'imports/assets.import';
import { STRINGS } from 'constants/strings.constant';
import { getInitials } from 'utils/functions.utils';
import { ProfileAvatarProps } from 'interfaces/profile.interface';
import './profile_avatar.ui.scss';

// The uploaded picture when there is one; otherwise the initials of the name; otherwise the generic
// placeholder. Renders a bare <img> / <div> so the parent decides the size and shape.
const ProfileAvatar = (props: ProfileAvatarProps) => {
  if (props.pictureUrl) {
    return <img src={props.pictureUrl} alt={STRINGS.profile.avatarAlt} />;
  }

  const initials = getInitials(props.name);
  if (initials) {
    return (
      <div className="profile_avatar_initials" style={props.style}>
        {initials}
      </div>
    );
  }

  return <img src={Assets.user} alt={STRINGS.profile.avatarAlt} />;
};

export default ProfileAvatar;
